<select
  [compareWith]="compareWith"
  [formControl]="control"
  [attr.aria-label]="ariaLabel"
  [attr.aria-describedby]="errorId"
  [attr.aria-invalid]="control.invalid"
  [ngClass]="inputClass"
  [ngStyle]="inputStyle"
  (focus)="handleFocus()"
  (blur)="handleBlur()"
  pluginsFormBaseControlStyle
  #inputRef
>
  @if (showDefault) {
    <option [value]="null" disabled>
      {{ defaultOptionLabel ?? ('select.defaultOption' | translate) }}
    </option>
  }
  <ng-content />
</select>
